export default "__VITE_ASSET__BOM_0$gb__"